export const formatAbsoluteDate = (date, options = {}) => {
    const { timeZoneFormat = 'local' } = options;
    const timestamp = new Date(date);
    const formattedDate = formatDate(timestamp, { timeZoneFormat });
    const formattedTime = formatTime(timestamp, {
        timeZoneFormat,
        hourFormat: timeZoneFormat === 'utc' ? '24' : '12',
        timeFormat: 'short',
    });
    return `${formattedDate} ${formattedTime}`;
};
export var FormattedDateFormat;
(function (FormattedDateFormat) {
    FormattedDateFormat["TimePassed"] = "time-passed";
})(FormattedDateFormat || (FormattedDateFormat = {}));
export const formatRelativeDate = (timestamp, options = {}) => {
    const { format = FormattedDateFormat.TimePassed } = options;
    switch (format) {
        case FormattedDateFormat.TimePassed:
            return getTimePassed(timestamp);
    }
};
const getTimePassed = (time) => {
    const currentTime = new Date();
    const eventTime = new Date(time);
    const timeDiff = currentTime.getTime() - eventTime.getTime();
    const seconds = Math.floor(timeDiff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (days > 365) {
        const years = Math.floor(days / 365);
        return `${years}y ago`;
    }
    if (days > 7) {
        const weeks = Math.floor(days / 7);
        return `${weeks}w ago`;
    }
    if (days > 0) {
        return `${days}d ago`;
    }
    if (hours > 0) {
        return `${hours}h ago`;
    }
    if (minutes > 0) {
        return `${minutes}m ago`;
    }
    return `${seconds}s ago`;
};
const getTimeZone = () => {
    const date = new Date();
    const timeZoneName = date.toLocaleString('en-US', { timeZoneName: 'short' }).split(' ').pop() || '';
    return timeZoneName;
};
const formatDate = (date, options = {}) => {
    const { dateFormat = 'long', timeZoneFormat = 'local' } = options;
    const timestamp = new Date(date);
    const month = timestamp.toLocaleString('en-US', {
        month: dateFormat === 'long' ? 'long' : 'short',
        timeZone: timeZoneFormat === 'utc' ? 'UTC' : undefined,
    });
    const day = timeZoneFormat === 'utc' ? timestamp.getUTCDate() : timestamp.getDate();
    const year = timeZoneFormat === 'utc' ? timestamp.getUTCFullYear() : timestamp.getFullYear();
    return `${month} ${day}, ${year}`;
};
const formatTime = (date, options = {}) => {
    const { timeFormat = 'short', timeZoneFormat = 'local', hourFormat = '12' } = options;
    const timestamp = new Date(date);
    let hours = timeZoneFormat === 'utc' ? timestamp.getUTCHours() : timestamp.getHours();
    const minutes = timeZoneFormat === 'utc'
        ? timestamp.getUTCMinutes().toString().padStart(2, '0')
        : timestamp.getMinutes().toString().padStart(2, '0');
    const timeZoneOffset = timestamp.getTimezoneOffset();
    const timeZoneOffsetHours = Math.abs(Math.floor(timeZoneOffset / 60))
        .toString()
        .padStart(2, '0');
    const timeZoneOffsetMinutes = (Math.abs(timeZoneOffset) % 60).toString().padStart(2, '0');
    const timeZoneSign = timeZoneOffset >= 0 ? '-' : '+';
    let formattedHours = hours.toString();
    let ampm = '';
    if (hourFormat === '12') {
        ampm = hours >= 12 ? ' PM' : ' AM';
        hours = hours % 12 || 12;
        formattedHours = hours.toString();
    }
    else {
        formattedHours = hours.toString().padStart(2, '0');
    }
    const formattedTime = `${formattedHours}:${minutes}${ampm}`;
    const timeZoneSuffix = timeZoneFormat === 'utc'
        ? ` ${timeZoneSign}${timeZoneOffsetHours}:${timeZoneOffsetMinutes} UTC`
        : ` ${getTimeZone()}`;
    if (timeFormat === 'short') {
        return `${formattedTime}${timeZoneSuffix}`;
    }
    return `${formattedTime} ${timeZoneSign}${timeZoneOffsetHours}:${timeZoneOffsetMinutes}${timeZoneSuffix}`;
};
//# sourceMappingURL=formatDate.js.map